import { BulkUpdateParams } from "../lib";

// "going forward" copy is suppressed as confusing
export function shouldShowGoingForwardMessage(_options: {
    enableDescriptionNormalization: boolean;
    hideGoingForwardMessage?: boolean;
    update: BulkUpdateParams["update"];
}): boolean {
    // keep them for easy re-enabling them in the future
    return false;
}
